module.exports = __webpack_public_path__ + "static/media/demo.502b798e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Projects/_projects/bcit-prog-tracker/demo.jpg
// module id = 265
// module chunks = 0